import React from 'react'

const SvgChecklistOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.53 13.22a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 15.333a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zM12 15a.75.75 0 01.75-.75h5a.75.75 0 010 1.5h-5A.75.75 0 0112 15zM10.53 7.47a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 9.583a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zM12 9.25a.75.75 0 01.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 4H4v16h16V4zM4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4z'
    />
  </svg>
)

export default SvgChecklistOutline
